export const CREATE_HS_BREADCRUMBS = (id?: string, name?: string) =>
  [
    {
      children: 'My community',
      href: '/my-community'
    },
    {
      children: 'My organization',
      href: '/my-community/my_organization/'
    },
    {
      children: 'Health systems',
      href: '/my-community/my_organization/health_systems',
      hidden: id === 'new'
    },
    {
      children: id === 'new' ? 'Health system creation' : name ?? ''
    }
  ].filter((item) => !item.hidden)

export const CREATE_EDIT_HS_TABS = [
  {
    key: 'general',
    label: 'Health System details'
  },
  {
    key: 'hospitals',
    label: 'Hospitals'
  },
  {
    key: 'users',
    label: 'Users'
  },
  {
    key: 'banking_setup',
    label: 'Banking setup'
  },
  {
    key: 'bank_accounts',
    label: 'Bank accounts'
  }
]

export const CREATE_EDIT_HS_TABS_KEYS = {
  general: 'general',
  hospitals: 'hospitals',
  users: 'users',
  banking_setup: 'banking_setup',
  bank_accounts: 'bank_accounts'
}

export const COMMUNITY_ACCESS_TOOLTIP_VALUES = {
  no_access:
    'Your Community President will not view your savings or information about your locally contracted agreements',
  view_only:
    'Your Community President will be able to view your savings targets but not  your locally contracted agreements',
  full_access:
    'Your Community President will be able to view your savings targets and your locally contracted agreements'
}
